import styled from 'styled-components';

export const AssetList = styled.div`
  z-index: 0;
  // margin-top:6px;
`;
